import React from 'react'
import { Row } from 'react-bootstrap'
import SectionHeading from '../../section-heading/SectionHeading'

const ContentBasic = ({ content }) => {
  const { preTitle, title, description, text, center } = content

  const textCenter = center ? 'text-center' : 'default'

  return (
    <Row className={`${textCenter}`}>
      {content.title ? (
        <SectionHeading
          preTitle={preTitle}
          title={title}
          description={description}
        />
      ) : (
        ''
      )}
      {text && text.html ? (
        <div
          dangerouslySetInnerHTML={{
            __html: text.html,
          }}
        />
      ) : (
        <p>{text}</p>
      )}
    </Row>
  )
}

export default ContentBasic
